import { TenderDisplayStatusEnum } from '@apiTypes'
import { PermissionType } from '@/types/permissions'

/**
 * Maps tender status to the permission type needed for modification.
 * Mirrors backend _tender_draft_or_change:
 * - Draft (or null/undefined) → add_tender (Contributor allowed)
 * - Non-draft → change_tender (Contributor blocked)
 *
 * Invariant: TenderDisplayStatusEnum.DRAFT maps 1:1 to backend tender.is_draft=True.
 * The API serializer emits DRAFT status if and only if is_draft is True.
 *
 * null/undefined is treated as DRAFT because new tenders before first save
 * have is_draft=True on the backend.
 */
export function getTenderModifyPermissionType(
  status: TenderDisplayStatusEnum | null | undefined,
): PermissionType {
  if (!status || status === TenderDisplayStatusEnum.DRAFT) return PermissionType.Create

  return PermissionType.Update
}
